import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import search from "../../../assets/icon-search.svg";
import styles from './styles.module.scss';

const Search = ({
                  value,
                  onChange
}) => {
  const {formatMessage} = useIntl();
  const placeholder = formatMessage({
    id: 'common.modal.search.placeholder',
    defaultMessage: 'Search'
  });

  return (
    <div className={styles.searchContainer}>
      <input
        type="text"
        className={styles.searchInput}
        placeholder={placeholder}
        value={value}
        onChange={event => onChange(event.target.value)}
      />
      <img src={search} alt="search" className={styles.searchIcon}/>
    </div>
  )
};

Search.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default Search;
